import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import router from '@/router'

const service = axios.create({
  baseURL: '/prod-api/admin',
  timeout: 15000
})

// 401 弹窗去重 flag
let authExpiredDialogShown = false

function handleAuthExpired() {
  if (authExpiredDialogShown) return
  authExpiredDialogShown = true
  MessageBox.confirm('登录已过期，请重新登录', '提示', {
    confirmButtonText: '重新登录',
    cancelButtonText: '取消',
    type: 'warning'
  }).finally(() => {
    authExpiredDialogShown = false
    store.dispatch('logout')
    router.push('/login')
  })
}

// 请求拦截器 - 自动带 token
service.interceptors.request.use(
  config => {
    const token = store.state.user.token || localStorage.getItem('admin_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 上传等接口直接返回 { url } 不含 code，跳过统一处理
    if (res.code === undefined) {
      return res
    }
    if (res.code !== 200) {
      Message({
        message: res.msg || '请求失败',
        type: 'error',
        duration: 3000
      })
      // token 失效 - 业务层 401
      if (res.code === 401) {
        handleAuthExpired()
      }
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    const status = error.response && error.response.status
    let msg = '网络错误，请稍后重试'
    if (status === 401) {
      // HTTP 401，复用同一个去重逻辑，不再额外弹 Message
      handleAuthExpired()
      return Promise.reject(error)
    } else if (status === 403) {
      msg = '权限不足'
    } else if (status === 404) {
      msg = '请求的资源不存在'
    } else if (status === 500) {
      msg = '服务器内部错误'
    }
    Message({ message: msg, type: 'error', duration: 3000 })
    return Promise.reject(error)
  }
)

export default service
